/**
 * The service worker (src/sw.ts): what opens the app without a network. Registered once the page has loaded (its
 * files are kept then, not fought over with the page's own); where there's none (an insecure origin: a dev stack on
 * the network over http; a native shell's web view), the app works as it did.
 */
import { ignore } from "./ignore.ts";

export function registerServiceWorker(): void {
  if (!(globalThis.isSecureContext && "serviceWorker" in navigator)) {
    return;
  }
  const register = () => {
    // The script itself never from the HTTP cache: a deploy's is seen at once.
    navigator.serviceWorker.register("/sw.js", { updateViaCache: "none" }).catch(ignore);
  };
  if (document.readyState === "complete") {
    register();
  } else {
    addEventListener("load", register, { once: true });
  }
}
